import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  AutoComplete,
  DatePicker,
  Space,
  Button,
  Tag,
  Input,
  Row,
  Col,
  Pagination,
  Tooltip,
} from "antd";
import { UserOutlined, InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import api from "utils/api";
import { IconSearch, IconPrint, IconEdit } from "Common/ReactIcons";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import AutoCompleteDebounce from "Components/AutoCompleteDebounce";
const { RangePicker } = DatePicker;
const columnName = {
  name: "Name",
  contact_number: "Contact No.",
  order_number: "Order No.",
  bill_number: "Bill No.",
  // bill_status: "Bill Status",
  amount: "Amount",
  payment_status: "Payment Status",
  payment_mode: "Payment Mode",
  action: " ",
};

const MyTableComponent = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const initialSearch = {
    ...props?.VendorDetail,
    title: "name",
    value: props?.VendorDetail?.name,
  };
  const [searchValue, setSearchValue] = useState(
    props?.VendorDetail ? initialSearch : ""
  );
  const [searchOptions, setSearchOptions] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({
    // billStatus: null,
    paymentStatus: null,
    paymentMode: null,
  });
  const [issearchLoading, setIsSearchLoading] = useState(false);
  const history = useHistory();
  // const billingIDObject = useRef({});
  const fetchData = async (params = {}) => {
    setLoading(true);
    const { searchValue, dateRange, filters, pagination } = params;

    // Construct query parameters
    const query = new URLSearchParams({
      patient_vendor_id:
        searchValue.title == "contact_number" || searchValue.title == "name"
          ? searchValue.patient_vendor_id || ""
          : "",
      billing_id:
        searchValue.title == "order_number" ||
        searchValue.title == "bill_number"
          ? searchValue.billing_id || ""
          : "",
      // search: searchValue || "",
      from_date:
        dateRange && dateRange.length === 2
          ? dateRange[0].format("YYYY-MM-DD")
          : "",
      to_date:
        dateRange && dateRange.length === 2
          ? dateRange[1].format("YYYY-MM-DD")
          : "",
      // bill_status: filters.billStatus ? filters.billStatus.join(",") : "",
      payment_status: filters.paymentStatus
        ? filters.paymentStatus.join(",")
        : "",
      payment_mode: filters.paymentMode ? filters.paymentMode.join(",") : "",
      page: pagination.current || 1,
      page_size: pagination.pageSize || 10,
    }).toString();

    try {
      const response = await api.fetchBillingHistory(query);
      if (response.data.status === 200 && response.data.message === "success") {
        const { results, count } = response.data.data;
        setData([]);
        let transResult = results.map((item, index) => ({
          ...item,
          key: index,
        }));
        setData(transResult);
        setPagination({
          ...pagination,
          total: count,
        });
      } else {
        console.error("Failed to fetch data: unexpected response format");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1, pageSize: 10 }));
    fetchData({
      searchValue,
      dateRange,
      filters,
      pagination: { current: 1, pageSize: 10 },
    });
  }, [searchValue, dateRange, filters]);

  const handleTableChange = (pagination, filters) => {
    // setPagination(pagination);
    setFilters({
      // billStatus: filters.bill_status ? filters.bill_status : null,
      paymentStatus: filters.payment_status ? filters.payment_status : null,
      paymentMode: filters.payment_mode ? filters.payment_mode : null,
    });
  };
  const renderTitle = (title) => <span>{columnName[title]}</span>;
  const renderItem = (item, index, parentindex, title) => {
    // billingIDObject.current[search_value] = billing_id;
    return {
      key: `${title} ${index}`,
      value:
        title == "order_number" || title == "bill_number"
          ? item.search_value
          : item.patient_vendor_id,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {item.search_value}
          <span>
            <UserOutlined /> {item.patient_vendor_id}
          </span>
        </div>
      ),
      patient_vendor_id: item.patient_vendor_id,
      billing_id: item.billing_id,
      title: title,
    };
  };
  const handleSearchChange = async (value) => {
    if (value) {
      setIsSearchLoading(true);
      try {
        const query = new URLSearchParams({ search: value }).toString();
        const response = await api.fetchBillingHistorySearch(query);
        if (
          response.data.status === 200 &&
          response.data.message === "success"
        ) {
          const { results, count } = response.data.data;
          if (count > 0) {
            const options = Object.keys(results).map(
              (objectKey, parentindex) => ({
                key: objectKey,
                label: renderTitle(objectKey),
                options: results[objectKey].map((item, index) =>
                  renderItem(item, index, parentindex, objectKey)
                ),
              })
            );
            setSearchOptions(options);
          }
        } else {
          console.error("Failed to fetch data: unexpected response format");
        }
      } catch (error) {
        console.error("Failed to fetch search options:", error);
      } finally {
        setIsSearchLoading(false);
      }
    } else {
      setSearchValue("");
      setSearchOptions([]);
    }
  };

  // const getBillStatusTag = (status) => {
  //   let color = "";
  //   switch (status) {
  //     case "Draft":
  //       color = "#2E90FA";
  //       break;
  //     case "Completed":
  //       color = "#08B939";
  //       break;
  //     case "Cancelled":
  //       color = "#F97066";
  //       break;
  //     case "Initiated":
  //       color = "#667085";
  //       break;
  //     default:
  //       color = "d9d9d9";
  //       break;
  //   }
  //   return <div style={{ color: color }}>{status}</div>;
  // };

  const getPaymentStatusTag = (record) => {
    let status = record.payment_status;
    let color = "";
    switch (status) {
      case "Paid":
        color = "#08B939";
        break;
      case "New":
        color = "blue";
        break;
      case "Pending":
        color = "#2E90FA";
        break;
      case "Draft":
        color = "#2E90FA";
        break;
      case "Partially paid":
        color = "#437FC8";
        break;
      case "Cancelled":
        color = "#F97066";
        break;
      default:
        color = "d9d9d9";
        break;
    }
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: color,
          gap: "8px",
        }}
      >
        <div
          style={{
            backgroundColor: color,
            width: "8px",
            height: "8px",
            borderRadius: "50%",
          }}
        ></div>
        <div>{status}</div>
        {record.reason && (
          <div>
            <Tooltip title={`Reason: ${record.reason}`}>
              <InfoCircleOutlined style={{ width: "8px", height: "8px" }} />
            </Tooltip>
          </div>
        )}
      </div>
    );
  };
  const formatNumberWithCommas = (number) => {
    return number.toLocaleString("en-IN");
  };
  const columns = [
    {
      title: columnName.name,
      dataIndex: "name",
      key: "name",
      // width: "25%",
      render: (text, record) => (
        <>
          <div>{text}</div>
          {/* <Row justify="start">
            <Col span={12}> */}
          <div className="sub-text">{record.patient_vendor_id}</div>
          {/* </Col>
            <Col span={12} className="status_container"> */}
          {record.is_newly_generated && !record.is_recently_paid && (
            <div key="is_newly_generated" className="newly_generated">
              Newly Generated
            </div>
          )}
          {record.is_recently_paid && (
            <div key="is_recently_paid" className="recently_paid">
              Recently Paid
            </div>
          )}
          {/* </Col> */}
          {/* </Row> */}
        </>
      ),
    },
    {
      // width: "20%",
      title: columnName.contact_number,
      dataIndex: "contact_number",
      key: "contact_number",
      render: (text, record) => (
        <div style={{ width: "100%" }}>{`${record?.country_code} ${text}`}</div>
      ),
    },
    // {
    //   title: columnName.order_number,
    //   dataIndex: "order_number",
    //   key: "order_number",
    // },
    {
      title: columnName.bill_number,
      dataIndex: "bill_number",
      key: "bill_number",
      // width: "20%",
      render: (text, record) => (
        <>
          <div>{text}</div>
          {record.bill_generated_date && (
            <div className="sub-text">
              {moment(record.bill_generated_date).format("MMM DD, YYYY")}
            </div>
          )}
        </>
      ),
    },
    // {
    //   title: columnName.bill_status,
    //   dataIndex: "bill_status",
    //   key: "bill_status",
    //   filters: [
    //     { text: "All", value: "" },
    //     { text: "Draft", value: "Draft" },
    //     { text: "Completed", value: "Completed" },
    //     { text: "Cancelled", value: "Cancelled" },
    //     { text: "Initiated", value: "Initiated" },
    //   ],

    //   render: (status) => getBillStatusTag(status),
    // },
    {
      title: columnName.amount,
      dataIndex: "amount",
      key: "amount",
      render: (text) => `₹${formatNumberWithCommas(Math.round(text))}`,
    },
    {
      title: columnName.payment_status,
      dataIndex: "payment_status",
      key: "payment_status",
      filters: [
        // { text: "All", value: "" },
        { text: "Paid", value: "Paid" },
        { text: "Partially paid", value: "Partially paid" },
        { text: "Pending", value: "Pending" },
        { text: "Draft", value: "Draft" },
        { text: "Cancelled", value: "Cancelled" },
      ],
      // width: 150,
      render: (status, record) => (
        <>
          {status != "New" && (
            <div>
              {getPaymentStatusTag(record)}
              {record.payment_date && (
                <div className="sub-text">
                  {moment(record.payment_date).format("MMM DD, YYYY")}
                </div>
              )}
            </div>
          )}
        </>
      ),
    },
    {
      title: columnName.payment_mode,
      dataIndex: "payment_mode",
      key: "payment_mode",
      filters: [
        // { text: "All", value: "" },
        { text: "Net Banking", value: "Net Banking" },
        { text: "Cash", value: "Cash" },
        { text: "UPI", value: "UPI" },
        { text: "Card", value: "Card" },
        { text: "Cheque", value: "Cheque" },
      ],
      render: (text) => (text === "OPEN" ? "" : text),
    },
    {
      // title: "Action",
      title: " ",
      key: "action",
      align: "right",
      render: (text, record) => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
        >
          {(record.payment_status == "Draft" ||
            record.payment_status == "Pending" ||
            record.payment_status == "Partially paid") && (
            <Button
              type="link"
              icon={<IconEdit />}
              onClick={() => {
                history.push(`${props.user_details.baseUrl}/edit-bill`, {
                  billing_id: record.billing_id,
                });
              }}
            />
          )}
          {record.receipt_link && (
            <Button
              key="receipt_link"
              type="link"
              icon={<IconPrint />}
              href={record.receipt_link}
              target="_blank"
              rel="noopener noreferrer"
            />
          )}
        </div>
      ),
      fixed: "right",
    },
  ];
  const disabledDate = (current) => {
    const endDate = dayjs().endOf("day");
    return current && current.isAfter(endDate);
  };
  return (
    <div className="billing-table">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <AutoCompleteDebounce
          options={searchOptions}
          style={{
            // width:"363px",
            // height:"48px",
            padding: "0px 24px 0px 16px",
          }}
          // dropdownStyle={{ width: "360px", }}
          onSelect={(value, option) => setSearchValue(option)}
          onSearch={handleSearchChange}
          // dropdownMatchSelectWidth={true}
          loading={issearchLoading}
          defaultValue={props?.VendorDetail ? initialSearch?.value : undefined}
        >
          <Input
            prefix={<IconSearch />}
            style={{ height: "100%", width: "412px" }}
            placeholder="Search by Name/Contact No./Bill No."
          />
        </AutoCompleteDebounce>
        <RangePicker
          value={dateRange}
          onChange={(dates) => setDateRange(dates)}
          style={{ height: 32 }}
          disabledDate={disabledDate}
        />
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        onChange={handleTableChange}
        rowKey="order_number"
        pagination={false}
        scroll={{ x: "max-content" }}
        // tableLayout="fixed"
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Pagination
          current={pagination.current || 1}
          pageSize={pagination.pageSize || 10}
          // pageSizeOptions={[5,10,15,20,50,100]}
          total={pagination.total}
          // showSizeChanger
          showTotal={(total) => `Total ${pagination.total} items`}
          onChange={(current, pageSize) => {
            setPagination((prev) => ({ ...prev, current, pageSize }));
            fetchData({
              searchValue,
              dateRange,
              filters,
              pagination: { current, pageSize },
            });
          }}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(MyTableComponent);
